exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown-item.active,\n.dropdown-item:active {\n  background-color: #495057;\n}\n.login-card {\n  width: 500px;\n  padding: 0px;\n  margin: auto;\n  position: absolute;\n  /* top: 50%; */\n  left: 50%;\n  transform: translate(-50%, -50%);\n  top: 30%;\n}\n.login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n", ""]);

// exports
